import React, { useState, useRef, useEffect } from 'react';

import './TopLinksSearch.css';

function TopLinksSearch(props) {
  const [searchItems, setSearchItems] = useState([]);

  const detectClickRef = useRef(null);
  useCloseSearchResults(detectClickRef);

  let getSearchResults = event => {
    event.persist();
    var regEx = new RegExp(event.currentTarget.value.toLocaleLowerCase(), 'gi');
    var highlight = `<span class="font-museo font-w-300">${event.currentTarget.value.toLocaleLowerCase()}</span>`;

    if (event.currentTarget.value.length > 2 || (event.currentTarget.value.length > 2 && event.which === 8)) {
      fetch(
        `/store/assembler?format=json&Dy=1&assemblerContentCollection=/content/Shared/Auto-Suggest%20Panels&isbusiness=false&Nty=1&Ntk=Main_Search_Interface&Ntt=${event.currentTarget.value}*&url=%2Fstore%2Fassembler%3Fformat%3Djson%26Dy%3D1%26assemblerContentCollection%3D%2Fcontent%2FShared%2FAuto-Suggest+Panels%26Ntt%3D${event.currentTarget.value}*&headers%5BAccept%5D=application%2Fjson&mimetype=application%2Fjson&handleAs=json`,
        // `http://localhost:9080/api/search-testing`,
        {
          method: 'GET',
        }
      )
        // .then(response => response.body)
        .then(response => response.text())
        .then(response => JSON.parse(response))
        .then(response => {
          setSearchItems(
            response.contents[0].autoSuggest[0].records.map((searchItem, index) =>
              response.contents[0].autoSuggest[0].records.length === index + 1 ? (
                <React.Fragment key={index}>
                  <div className="py-10 px-15" data-index={searchItem.id}>
                    <a
                      className="hover:underline font-w-700"
                      href={
                        searchItem.attributes['sasktel.link']
                          ? `/store/${searchItem.attributes['sasktel.link'][0]}`
                          : searchItem.attributes['P_Product_WCM_URL'][0]
                      }
                      onClick={() =>
                        searchResultsAnalyticsPush(
                          event,
                          event.currentTarget ? event.currentTarget.value : '',
                          response.contents[0].autoSuggest[0].records.length,
                          searchItem.attributes['product.displayName']
                            ? searchItem.attributes['product.displayName'][0]
                            : searchItem.attributes['P_Product_Name'][0]
                        )
                      }
                      dangerouslySetInnerHTML={{
                        __html: (searchItem.attributes['product.displayName']
                          ? searchItem.attributes['product.displayName'][0]
                          : searchItem.attributes['P_Product_Name'][0]
                        ).replace(regEx, highlight),
                      }}
                    ></a>
                  </div>
                  <div className="py-10 px-15" key={index}>
                    <a className="hover:underline font-w-700 font-mont text-white text-12 leading-12 uppercase tracking-1" href="#" onClick={submitSearch}>
                      See all results
                    </a>
                  </div>
                </React.Fragment>
              ) : (
                <div key={index} className="py-10 px-15" data-index={searchItem.id}>
                  <a
                    className="hover:underline font-w-700"
                    href={
                      searchItem.attributes['sasktel.link']
                        ? `/store/${searchItem.attributes['sasktel.link'][0]}`
                        : searchItem.attributes['P_Product_WCM_URL'][0]
                    }
                    onClick={() =>
                      searchResultsAnalyticsPush(
                        event,
                        event.currentTarget ? event.currentTarget.value : '',
                        response.contents[0].autoSuggest[0].records.length,
                        searchItem.attributes['product.displayName']
                          ? searchItem.attributes['product.displayName'][0]
                          : searchItem.attributes['P_Product_Name'][0]
                      )
                    }
                    dangerouslySetInnerHTML={{
                      __html: (searchItem.attributes['product.displayName']
                        ? searchItem.attributes['product.displayName'][0]
                        : searchItem.attributes['P_Product_Name'][0]
                      ).replace(regEx, highlight),
                    }}
                  ></a>
                </div>
              )
            )
          );
        });
    } else {
      setSearchItems([]);
    }
  };

  let getPopularSearches = event => {
    event.persist();

    fetch(
      '/rest/model/com/sasktel/commerce/browse/BrowseActor/popularSearches?url=%2Frest%2Fmodel%2Fcom%2Fsasktel%2Fcommerce%2Fbrowse%2FBrowseActor%2FpopularSearches&headers%5BAccept%5D=application%2Fjson&mimetype=application%2Fjson&handleAs=json',
      // `http://localhost:9080/api/popular-testing`,
      {
        method: 'GET',
      }
    )
      // .then(response => response.body)
      .then(response => response.text())
      .then(response => JSON.parse(response))
      .then(response => {
        setSearchItems(
          response.popularSearches.popularSearches.map((searchItem, index) =>
            index === 0 ? (
              <React.Fragment key={index}>
                <div className="pb-10 px-15">
                  <span class="font-mont font-w-700 text-10 leading-10 tracking-1 uppercase">{response.popularSearches.heading}</span>
                </div>
                <div className="py-10 px-15" data-index={searchItem.id}>
                  <a
                    className="hover:underline font-w-300"
                    href={searchItem.url}
                    onClick={() =>
                      searchResultsAnalyticsPush(
                        event,
                        event.currentTarget ? event.currentTarget.value : '',
                        response.contents[0].autoSuggest[0].records.length,
                        searchItem.name
                      )
                    }
                  >
                    {searchItem.name}
                  </a>
                </div>
              </React.Fragment>
            ) : (
              <div key={index} className="py-10 px-15" data-index={searchItem.id}>
                <a
                  className="hover:underline font-museo font-w-300"
                  href={searchItem.url}
                  onClick={() =>
                    searchResultsAnalyticsPush(
                      event,
                      event.currentTarget ? event.currentTarget.value : '',
                      response.contents[0].autoSuggest[0].records.length,
                      searchItem.name
                    )
                  }
                >
                  {searchItem.name}
                </a>
              </div>
            )
          )
        );
      });
  };

  let searchResultsAnalyticsPush = (event, searchTerm, resultLength, result) => {
    event.persist();
    console.log(event, searchTerm, resultLength, result);
  };

  let clearSearch = () => {
    setSearchItems([]);
  };

  let submitSearch = () => {
    document.querySelector('#search_form_id_regular').submit();
  };

  function useCloseSearchResults(ref) {
    useEffect(() => {
      function handleClickOutsideSearch(event) {
        if (ref.current && !ref.current.contains(event.target) && searchItems !== []) {
          setSearchItems([]);
        }
      }
      document.addEventListener('mousedown', handleClickOutsideSearch);
      return () => {
        document.removeEventListener('mousedown', handleClickOutsideSearch);
      };
    }, [ref]);
  }

  return (
    <div ref={detectClickRef} className="relative">
      {!props.isSearchToggled && !props.isMobile && (
        <div className="w-355 border-charcoal border-l-1 border-r-1 flex desktop">
          <form id="search_form_id_regular" className="flex w-full" autoComplete="off" action="https://www.sasktel.com/store/search_control">
            <fieldset className="h-60 m-0 p-0 flex flex-row w-full">
              <label className="hidden" htmlFor="atg_store_searchInput_regular">
                Search terms
              </label>
              <input
                autoComplete="off"
                id="atg_store_searchInput_regular"
                className="h-60 m-0 p-15 text-17 leading-22 text-white bg-almost-black font-museo flex flex-grow w-full placeholder-middle-grey outline-none"
                name="Ntt"
                placeholder="What are you looking for?"
                onKeyUp={getSearchResults}
                onClick={getPopularSearches}
              ></input>
            </fieldset>
            <button type="submit" className="mr-15 my-auto w-18 h-18 flex" aria-label="Submit search">
              <svg width="16" height="16" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                <path
                  fill="#aaaaaa"
                  d="M15.781 13.834l-3.116-3.116c-0.141-0.141-0.331-0.219-0.531-0.219h-0.509c0.863-1.103 1.375-2.491 1.375-4 0-3.591-2.909-6.5-6.5-6.5s-6.5 2.909-6.5 6.5 2.909 6.5 6.5 6.5c1.509 0 2.897-0.512 4-1.375v0.509c0 0.2 0.078 0.391 0.219 0.531l3.116 3.116c0.294 0.294 0.769 0.294 1.059 0l0.884-0.884c0.294-0.294 0.294-0.769 0.003-1.063zM6.5 10.5c-2.209 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 4 1.787 4 4 0 2.209-1.787 4-4 4z"
                ></path>
              </svg>
            </button>
          </form>
        </div>
      )}
      {props.isSearchToggled && props.isMobile && (
        <div className="w-full flex mobile z-20 absolute">
          <form id="search_form_id_regular" className="flex w-full" autoComplete="off" action="https://www.sasktel.com/store/search_control">
            <fieldset className="h-60 m-0 p-0 flex flex-row w-full">
              <label className="hidden" htmlFor="atg_store_searchInput_regular">
                Search terms
              </label>
              <input
                autoComplete="off"
                id="atg_store_searchInput_regular"
                className="h-60 m-0 p-20 text-17 leading-22 text-middle-grey bg-almost-black font-museo font-w-300 flex flex-grow w-full placeholder-middle-grey outline-none"
                name="Ntt"
                placeholder="What are you looking for?"
                onKeyUp={getSearchResults}
                onClick={getPopularSearches}
              ></input>
            </fieldset>
          </form>
        </div>
      )}
      <div ref={detectClickRef} className={`resultDiv z-50 bg-charcoal text-white text-14 leading-18 absolute w-full ${searchItems.length ? 'py-10' : ''}`}>
        {searchItems}
        <button
          type="button"
          className={`absolute top-10 right-10 p-0m-0z-50 ${searchItems.length ? 'inline-block' : 'hidden'}`}
          style={searchItems.length ? { top: '10px', right: '10px' } : {}}
          aria-label="Hide auto suggestions"
          onClick={clearSearch}
        >
          <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 20">
            <path
              fill="#aaaaaa"
              d="M7.576 10l4.832-4.832c0.122-0.122 0.122-0.32 0-0.442l-0.884-0.884c-0.122-0.122-0.32-0.122-0.442 0l-4.832 4.832-4.832-4.833c-0.122-0.122-0.32-0.122-0.442 0l-0.884 0.884c-0.122 0.122-0.122 0.32 0 0.442l4.833 4.833-4.833 4.832c-0.122 0.122-0.122 0.32 0 0.442l0.884 0.884c0.122 0.122 0.32 0.122 0.442 0l4.833-4.832 4.832 4.832c0.122 0.122 0.32 0.122 0.442 0l0.884-0.884c0.122-0.122 0.122-0.32 0-0.442l-4.832-4.832z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );
}

export default TopLinksSearch;
